import { render } from "./AposLogoPadless.vue?vue&type=template&id=88dc0f34"
const script = {}

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposLogoPadless.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88dc0f34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88dc0f34', __exports__)) {
    api.reload('88dc0f34', __exports__)
  }
  
  module.hot.accept("./AposLogoPadless.vue?vue&type=template&id=88dc0f34", () => {
    api.rerender('88dc0f34', render)
  })

}


export default __exports__